import { Link } from 'react-router-dom';
import { routeConstants } from 'shared/constants';
import qs from 'qs';

const NavbarItem = ({ navData, activeMenu, onMenuHover, onMenuClick }) => {
  const { link, parentCategories, title, _id } = navData;

  const subCategories = parentCategories.length
    ? parentCategories.reduce(
        (subcategories, category) =>
          subcategories.concat(
            category.subCategories.map((subcategory) => ({
              ...subcategory,
              category: category.slug,
            }))
          ),
        []
      )
    : [];

  if (link === null) {
    return (
      <li
        className={`menu_text ${
          activeMenu === _id ? 'show_dropdown changearrow' : ''
        }`}
        onMouseEnter={() => onMenuHover(_id)}
        onMouseLeave={() => onMenuHover('')}
        onClick={() => onMenuClick(_id)}
      >
        <a href="/" onClick={(e) => e.preventDefault()}>
          {title}
          <i className="fas fa-chevron-down" />
        </a>
        <div className="dropdown_block animatedfast animatedFadeInUp fadeInUpFast">
          <div className="drodown_body">
            <ul className="sub_menu_list">
              {subCategories.length
                ? subCategories.map((categoryItem) => {
                    const {
                      title,
                      _id,
                      productTypes,
                      category,
                      slug: subCategory,
                    } = categoryItem;

                    const subQueryData = {
                      category,
                      subCategory,
                    };

                    return (
                      <li key={_id}>
                        <h6 className="subcatagory_menu">
                          <Link
                            to={`${
                              routeConstants.PRODUCTS.path
                            }/?${qs.stringify(subQueryData)}`}
                          >
                            {title}
                          </Link>
                        </h6>
                        {productTypes.map((productType) => {
                          const { slug } = productType;
                          const typeQueryData = {
                            category,
                            subCategory,
                            productType: slug,
                          };

                          return (
                            <Link
                              to={`${
                                routeConstants.PRODUCTS.path
                              }/?${qs.stringify(typeQueryData)}`}
                              key={productType._id}
                            >
                              {productType.title}
                            </Link>
                          );
                        })}
                        <div className="menu_seperator" />
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </div>
      </li>
    );
  } else {
    return (
      <li className="menu_text">
        <Link to={link}>{title}</Link>
      </li>
    );
  }
};

export default NavbarItem;
